export function IsJsonString(jsonString: string) {
  try {
    var o = JSON.parse(jsonString);

    if (o && typeof o === 'object') {
      return true;
    }
  } catch (e) {}

  return false;
}
